import styled from "styled-components";

export const Th = styled.th<{ $width?: string }>`
  padding: 10px 12px;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  color: #111827;
  border-bottom: 1px solid #e5e7eb;
  position: relative;
  user-select: none;
  background: #f9fafb;
`;

export const HeadInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

/* TitleBtn만으로 필터 상태를 표현 + 클릭으로 팝오버 오픈 */
export const TitleBtn = styled.button`
  all: unset;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-weight: 800;
  color: #111827;
  padding: 6px 10px;
  border-radius: 10px;
  position: relative;

  /* 기본 호버 */
  &:hover {
    background: #f3f4f6;
  }
  &:active {
    transform: translateY(1px);
  }
  &:focus-visible {
    outline: 2px solid #6366f1;
    outline-offset: 2px;
  }

  /* 필터가 적용되었을 때의 디테일 강조 */
  &[data-filtered] {
    background: #eef2ff; /* indigo-100 */
    color: #4338ca; /* indigo-700 */
    box-shadow: 0 1px 0 rgba(67, 56, 202, 0.05),
      inset 0 1px 2px rgba(67, 56, 202, 0.08);
    border: 1px solid #c7d2fe;

    .text {
      text-decoration: underline 2px;
      text-underline-offset: 3px;
    }
  }

  /* 좌측 텍스트 */
  .text {
    line-height: 1;
  }

  /* 우측 작은 초록 점 (필터됨 표시) */
  .dot {
    width: 6px;
    height: 6px;
    border-radius: 9999px;
    background: #10b981; /* emerald-500 */
    box-shadow: 0 0 0 2px #fff;
  }

  /* 현재 필터 값 힌트 (잘리는 경우 ... 처리) */
  .hint {
    max-width: 120px;
    padding: 2px 6px;
    border-radius: 999px;
    font-weight: 700;
    font-size: 11px;
    line-height: 1;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    color: #334155;
    box-shadow: 0 1px 0 rgba(17, 24, 39, 0.02);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const SortCaret = styled.span<{ $active?: boolean; $asc?: boolean }>`
  display: inline-flex;
  width: 10px;
  height: 10px;

  &::before {
    content: "${({ $active, $asc }) => ($active ? ($asc ? "▲" : "▼") : "")}";
    font-size: 10px;
    line-height: 1;
    opacity: ${({ $active }) => ($active ? 0.6 : 0)};
    transition: opacity 140ms ease;
  }
`;
